module.exports = __webpack_public_path__ + "static/media/logo_regions.833e6a38.png";